import React, { Suspense } from "react";
import {
  Col,
  Dialog,
  Gap,
  InputField,
  Row,
  SelectField,
  Switchbox,
} from "../../../ppui";

import { Snackbar } from "../../../ppui/snackbar";
import ErrorBoundary from "../../../utils/error-boundary";
import BankList from "./bank-list";
import { BANK_INPUT_FIELDS } from "./banking-constant";
import useBankingService from "./use-banking-service";

function Banking() {
  const {
    handleSubmitFn,
    getInputFieldPropsFn,
    organisationBanking,
    createUpdateLoading,
    handleClickOpen,
    handleClose,
    open,
    setOpen,
    handleResetForm,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    resource,
    isPrimaryBankError,
  } = useBankingService();

  return (
    <>



      <ErrorBoundary
        fallback={<p>Something went wrong in fetching BankList...</p>}
      >
        <Suspense fallback={<p>Loading BankList...</p>}>
          <BankList
            resource={resource}
            handleResetForm={handleResetForm}
            setOpen={setOpen}
            getInputFieldPropsFn={getInputFieldPropsFn}
            handleClickOpen={handleClickOpen}
            handleSubmitFn={handleSubmitFn}
          />
        </Suspense>
      </ErrorBoundary>

      <Gap height={50} />

      {/* Modal */}
      <Dialog
        title={`${organisationBanking?.org_bank_id ? "Update" : "Create New"}  Bank`}
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        loading={createUpdateLoading}
        buttonName={`${organisationBanking?.org_bank_id ? "Update" : "Submit"}`}
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(BANK_INPUT_FIELDS.bank_name.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(BANK_INPUT_FIELDS.branch_name.name)}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(BANK_INPUT_FIELDS.account_no.name)}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(BANK_INPUT_FIELDS.ifsc_no.name)}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              placeholder="Select Here..."
              {...getInputFieldPropsFn(BANK_INPUT_FIELDS.account_type.name)}
            />
          </Col>

          <Col sm={6}>
            <Switchbox
              {...getInputFieldPropsFn(BANK_INPUT_FIELDS.is_primary.name)}
            />
          </Col>
        </Row>
        {isPrimaryBankError &&
          <Col sm={6}>
            <Switchbox
              {...getInputFieldPropsFn(BANK_INPUT_FIELDS.is_force_primary.name)}
            />
          </Col>
        }
      </Dialog>

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default Banking;
